import { Command } from 'cmdk';
import type { IconName } from '@customerio/pluma-icons';
import { Box, Flex, Icon, Text } from '@customerio/pluma-components/react';
import type { PositionedLocalCommandResultGroup } from './local-command-result-plan';

export type LocalCommandsSectionProps = {
  commandGroups: PositionedLocalCommandResultGroup[];
  onSelect: (action: () => void | Promise<void>, position: number) => void;
};

export function LocalCommandsSection({ commandGroups, onSelect }: LocalCommandsSectionProps) {
  return (
    <>
      {commandGroups.map((group) => (
        <Command.Group key={group.id} heading={group.heading}>
          {group.commands.map((cmd, index) => (
            <Command.Item
              key={`local-${cmd.id}`}
              value={`local-${cmd.id}`}
              onSelect={() => onSelect(cmd.onSelect, 1 + group.baseOffset + index)}
              asChild
            >
              <Box alignItems="flex-start" gap="050" display="flex">
                <Icon
                  mt="025"
                  size="sm"
                  sizeVersion="v2"
                  color="base"
                  name={
                    // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
                    (cmd.icon ?? 'command') as IconName
                  }
                />
                <Flex direction="column" w="full">
                  <Text text="product-p" truncate w="full">
                    {cmd.label}
                  </Text>
                  {cmd.description != null ? (
                    <Text size="xxs" color="subtle" truncate w="full">
                      {cmd.description}
                    </Text>
                  ) : null}
                </Flex>
              </Box>
            </Command.Item>
          ))}
        </Command.Group>
      ))}
    </>
  );
}
